import {
  BLOG_AUTHOR_URL,
  BLOG_URL,
  CASE_STUDIES_URL,
  WEBINAR_URL
} from '../const/url';
import { AppDeviceSize } from '../enums/app-device-size';

export const chooseRandomElements: <T>(
  injectedParentObject: Array<T>,
  numberOfChoosenObjects: number
) => Array<T> = (injectedParentObject, numberOfChoosenObjects) =>
  [...injectedParentObject]
    .sort(() => Math.random() - 0.5)
    .slice(0, numberOfChoosenObjects);

export const addSpace: (
  spaceNamed: string
) => { margin: string } | undefined = spaceNamed => {
  switch (spaceNamed) {
    case 'small':
      return { margin: '10px' };
    case 'medium':
      return { margin: '25px' };
    case 'large':
      return { margin: '80px' };
    default:
      return undefined;
  }
};

export const emptyWyswigString = '<p><br></p>';

export const checkIfDecimal = (text: string): boolean => text.includes('.');

export const removeTags = (text: string): string =>
  text.replace(/<\/?[^>]+(>|$)/g, '');

export const blogCategoryUrl = (category: string): string =>
  `${BLOG_URL}/${category.replace(/_/g, '-')}`.toLocaleLowerCase();

export const blogArticleUrl = (slug: string, category: string): string =>
  `${BLOG_URL}/${category.replace(/_/g, '-')}${slug}`.toLocaleLowerCase();

export const caseStudyArticleUrl = (slug: string): string =>
  `${CASE_STUDIES_URL}/${slug}`.toLocaleLowerCase();

export const authorUrl = (slug: string): string =>
  `${BLOG_AUTHOR_URL}/${slug.replace(/_/g, '-')}`.toLocaleLowerCase();

export const webinarArticleUrl = (slug: string): string =>
  `${WEBINAR_URL}/${slug.replace('/', '')}`.toLocaleLowerCase();

export const checkDevice = (device: string): number => {
  switch (device) {
    case 'desktop':
      return AppDeviceSize.REGULARDESKTOP;
    case 'small_desktop':
      return AppDeviceSize.SMALLDESKTOP;
    case 'tablet':
      return AppDeviceSize.TABLET;
    case 'mobile':
      return AppDeviceSize.MOBILE;
    default:
      return 0;
  }
};

export const videoExtension: string[] = ['mp4'];

export const checkIfVideo = (extension: string): boolean =>
  videoExtension.includes(extension);
export const marginBetweenItemsClasses = (
  marginBetweenItems: string
): {
  large: boolean;
  medium: boolean;
  small: boolean;
  default: boolean;
  none: boolean;
} => {
  return {
    large: marginBetweenItems === 'large',
    medium: marginBetweenItems === 'medium',
    small: marginBetweenItems === 'small',
    default: marginBetweenItems === 'default',
    none: marginBetweenItems === 'none'
  };
};

interface IWithSystem {
  system: {
    id: string;
  };
}

export const filterById: <T extends IWithSystem>(
  data: Array<T>
) => Array<T> = data =>
  data.filter((v, i, a) => a.findIndex(t => t.system.id === v.system.id) === i);

export const Truthy = /^\s*(true|1)\s*$/i;

export const createSlug = (title: string): string =>
  title
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-');
